import React from "react";
var FilterLabels = function (_a) {
    var LabelText = _a.LabelText, closeBtn = _a.closeBtn, FilterAction = _a.FilterAction;
    return (React.createElement("div", { className: "ed-filter-label-wrapper" }, closeBtn ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tag-container" },
            React.createElement("div", { className: "ed-filter-label-text" }, LabelText),
            React.createElement("span", { className: "edel-icon-close hand_cursor", onClick: function () { return FilterAction(LabelText); } })))) : (React.createElement("div", { className: "tag-container clear-all-fix" },
        React.createElement("div", { className: "ed-filter-label-text", onClick: function () { return FilterAction(LabelText); } }, LabelText)))));
};
export default FilterLabels;
